module.exports = __webpack_public_path__ + "img/custom-btn-13012022.6a793cad.svg";